import { useState } from "react";
import ReactQuill from "react-quill-new";
import { Card, CardBody, Col, Row } from "reactstrap";
import { StandardEditorTitle } from "../../../../Constants/Constants";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { StandardQuillText } from "../../../../Data/Miscellaneous/Editor";

const StandardEditor = () => {
  const [value, setValue] = useState(StandardQuillText);
  return (
    <Row>
      <Col sm="12">
        <Card>
          <CommonCardHeader title={StandardEditorTitle} />
          <CardBody>
            <ReactQuill value={value} onChange={setValue} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};
export default StandardEditor;
